import RegisterContainer from './RegisterContainer';

export default RegisterContainer;
